export const PROGRAMMING_BUILDING_VIEWS: Record<string, string> = {
  CALCULATOR_FORM: 'calculator_form',
  CALCULATORS_LIST: 'calculators_list',
  SCENARIOS: 'scenarios',
  SCENARIO_DETAILS: 'scenario_details',
  SCENARIO_SUMMARY: 'summary',
  TOTAL_PROGRAM_DETAILS: 'total_program_details',
};

export const SCENARIO_LIST_TYPES = {
  MACRO: 'macro',
  DEPARTMENTS: 'departments',
  BUILDING: 'building',
  FLOOR: 'floor',
};
